/* eslint-disable no-underscore-dangle */
import axiosBackEnd from "../../config/axios/axios-back-end";

const activateOnboardingUser = async (data) => {
  const res = await axiosBackEnd.post(
    `/api/onboarding/users/${data.id}/activate`,
    data,
  );
  return res.data;
};

const inviteOnboardingUser = async (data) => {
  const res = await axiosBackEnd.post(
    `/api/onboarding/users/${data.id}/resend-invitation`,
    data,
  );
  return res.data;
};

const getOnboardingUser = async (id, searchParams) => {
  const response = await axiosBackEnd.get(
    `/api/onboarding/users/${id}?${searchParams || ""}`,
  );
  return response.data;
};

const searchOnboardingUser = async (searchParams) => {
  const response = await axiosBackEnd.get(
    `/api/onboarding/users?${searchParams || ""}`,
  );
  return response.data;
};

export { activateOnboardingUser, inviteOnboardingUser, getOnboardingUser, searchOnboardingUser };
